
<div class="loader-overlay" [ngStyle]="{
  'background-color': us.getTrainerMode() ? us.filterMenuOpen?'white':'#EFEFEF' : 'rgba(255, 255, 255, 0.7)'
}">
  <ion-spinner name="lines"></ion-spinner>
</div>
